import { SectionsTreeNode } from '../types';

export const flattenPageIds = (sections: SectionsTreeNode[]): string[] => {
  const allPageIds: string[] = [];

  function traverse(nodes: SectionsTreeNode[]) {
    for (const node of nodes) {
      if (node.pageIds) {
        allPageIds.push(...node.pageIds);
      }
      if (node.children) {
        traverse(node.children);
      }
    }
  }

  traverse(sections);
  return allPageIds;
};
